var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLimitAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.3809,
    fill: "#F7C143",
    stroke: "#F7C143",
    strokeWidth: 1.23828
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2074 9L15.2074 15.5455L13.6648 15.5455L13.6648 9L15.2074 9ZM14.4318 16.4744C14.6761 16.4744 14.8864 16.5554 15.0625 16.7173C15.2386 16.8821 15.3267 17.0795 15.3267 17.3097C15.3267 17.5426 15.2386 17.7401 15.0625 17.902C14.8864 18.0668 14.6761 18.1491 14.4318 18.1491C14.1847 18.1491 13.9744 18.0668 13.8011 17.902C13.625 17.7401 13.5369 17.5426 13.5369 17.3097C13.5369 17.0795 13.625 16.8821 13.8011 16.7173C13.9744 16.5554 14.1847 16.4744 14.4318 16.4744Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimitAction);
export default __webpack_public_path__ + "static/media/limit-action.06cb58315f0caecd02f2c4de56291096.svg";
export { ForwardRef as ReactComponent };